
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"respondentHash"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baselineHandle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interventionHandle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deployments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"as"},"value":{"kind":"EnumValue","value":"ANY"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deploymentList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"deploymentHandle","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"string"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"baselineHandle"}},{"kind":"Variable","name":{"kind":"Name","value":"interventionHandle"}}]}}]}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deploymentHandle"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"as"},"value":{"kind":"EnumValue","value":"ANY"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"anyRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"respondentHash"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"respondentHash"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"EnumValue","value":"GLOBAL"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentProgress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deploymentHandle"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"baselineHandle"}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deployment"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deploymentHandle"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"devTags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GAD_CP"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mx_319_1_mc_1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mx_320_4_mc_1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mx_321_1_mc_1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mx_325_2_mc_1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mx_325_3_mc_1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"PHQ8_CP"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"PPR_SUM"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"QMI_SUM"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sl_252"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sl_253"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sl_254"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sl_266"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sl_267"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sl_268"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":1088}};
    doc.loc.source = {"body":"query ($respondentHash: String, $baselineHandle: String, $interventionHandle: String) {\n    deployments(as: ANY) {\n        deploymentList(filter: { in: { field: \"deploymentHandle\", string: [$baselineHandle, $interventionHandle] } }) {\n            hash\n            deploymentHandle\n        }\n    }\n\n    roles(as: ANY) {\n        anyRole(respondentHash: [$respondentHash], context: GLOBAL) {\n            assignmentProgress(deploymentHandle: [$baselineHandle]) {\n                deployment {\n                    deploymentHandle\n                }\n                completed\n                devTags {\n                    GAD_CP\n                    mx_319_1_mc_1\n                    mx_320_4_mc_1\n                    mx_321_1_mc_1\n                    mx_325_2_mc_1\n                    mx_325_3_mc_1\n                    PHQ8_CP\n                    PPR_SUM\n                    QMI_SUM\n                    sl_252\n                    sl_253\n                    sl_254\n                    sl_266\n                    sl_267\n                    sl_268\n                }\n            }\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
